import { COUNTRIES } from "@/data/countries";
import { COUNTRY_COORDS } from "@/lib/countryCoords";
import { MAJOR_CITIES } from "@/data/majorCities";

const norm = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
export const flagEmoji = (code) => (code && code.length === 2 ? String.fromCodePoint(...[...code.toUpperCase()].map((ch) => 127397 + ch.charCodeAt(0))) : "🌍");

let INDEX = null;
function build() {
  const byCode = Object.fromEntries(COUNTRIES.map((c) => [c.code, c]));
  const out = [];
  for (const c of COUNTRIES) {
    const ll = COUNTRY_COORDS[c.code];
    if (!ll) continue;
    out.push({ id: `country-${c.code}`, kind: "country", name: c.name, code: c.code, lat: ll[0], lng: ll[1], sub: c.capital ? `Capital: ${c.capital}` : "Country", country: c, altitude: 1.4, n: norm(c.name) });
    if (c.capital) out.push({ id: `capital-${c.code}`, kind: "city", capital: true, name: c.capital, code: c.code, lat: ll[0], lng: ll[1], sub: `Capital of ${c.name}`, country: c, altitude: 0.9, n: norm(c.capital) });
  }
  for (const [name, code, lat, lng] of MAJOR_CITIES) {
    const c = byCode[code];
    out.push({ id: `city-${code}-${norm(name).replace(/[^a-z]+/g, "-")}`, kind: "city", name, code, lat, lng, sub: c ? `City in ${c.name}` : "City", country: c || null, altitude: 0.9, n: norm(name) });
  }
  return out;
}

/** Ranked places for a query: exact > starts-with > word-start > contains; countries before cities on ties. */
export function searchPlaces(query, limit = 8) {
  if (!INDEX) INDEX = build();
  const q = norm(query);
  if (q.length < 2) return [];
  const scored = [];
  for (const p of INDEX) {
    let s = -1;
    if (p.n === q) s = 100;
    else if (p.n.startsWith(q)) s = 80;
    else if (p.n.split(/[\s'-]+/).some((w) => w.startsWith(q))) s = 60;
    else if (p.n.includes(q)) s = 40;
    if (s < 0) continue;
    if (p.kind === "country") s += 3; else if (p.capital) s += 1;
    scored.push([s - p.n.length / 100, p]);
  }
  return scored.sort((a, b) => b[0] - a[0]).slice(0, limit).map((x) => x[1]);
}

export function placeCount() {
  if (!INDEX) INDEX = build();
  return { countries: INDEX.filter((p) => p.kind === "country").length, cities: INDEX.filter((p) => p.kind === "city").length };
}
